<div
  class="bg-white rounded-xl shadow-sm p-6 w-full h-full flex flex-col gap-4"
>
  <div class="h-9">
    @if (showTypeSwitcher) {
      <div class="inline-flex w-auto items-center">
        <ng-select
          [(ngModel)]="chartType"
          (change)="onTypeChange($event)"
          [items]="chartTypes"
          [clearable]="false"
          class="custom-select text-sm"
        >
          <ng-template ng-option-tmp let-item="item">
            {{ "charts.type." + item | translate }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            {{ "charts.type." + item | translate }}
          </ng-template>
        </ng-select>
      </div>
    }
  </div>

  <div class="h-[350px]">
    <apx-chart
      [chart]="chartOptions.chart!"
      [dataLabels]="chartOptions.dataLabels!"
      [labels]="chartOptions.labels!"
      [plotOptions]="chartOptions.plotOptions!"
      [series]="chartOptions.series!"
      [title]="chartOptions.title!"
      [xaxis]="chartOptions.xaxis!"
      [yaxis]="chartOptions.yaxis!"
    />
  </div>
</div>
